import React from "react";
import { Box, Typography, Autocomplete, TextField } from "@mui/material";
import { styles } from "./DropDownStyles"
export const Dropdown = ({ options, value, onChange, label, errorMessage, error, placeholder, ...rest }: any) => (
    <Box sx={styles.dropDownBox}>
        <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", flexDirection: "row", alignItems: "center" }}>
            <Typography variant="h6" fontSize={16} fontWeight={500} mt={1} gutterBottom>
                {label}
            </Typography>
            {<Typography fontSize={10} sx={{ color: error ? "red" : "white" }} >{errorMessage ? errorMessage : " . "}</Typography>}
        </Box>
        <Autocomplete
            options={options}
            value={value}
            size="small"
            onChange={(event, newValue) => onChange(newValue)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    placeholder={"" || placeholder}
                    InputProps={{
                        ...params.InputProps,
                        style: styles.fieldTextColor,
                    }}
                    sx={styles.textColor}
                />
            )}
            {...rest}
        />
    </Box>
);